import * as React from "react";
import { DataGridPremium, GridColDef, GridColumnGroupingModel, GridRowsProp } from "@mui/x-data-grid-premium";

export interface ReportsDataGridPanelProps {
    sessionId: string;
    columns?: GridColDef[];
    data?: GridRowsProp;
    columnGroupingModel?: GridColumnGroupingModel;
}

const ReportsDataGridDataGridPanel: React.FC<ReportsDataGridPanelProps> = (props) => {
    return (
        <DataGridPremium 
            columns={props.columns ?? []} 
            rows={props.data ?? []}
            experimentalFeatures={{ columnGrouping: true }}
            columnGroupingModel={props.columnGroupingModel}
            autoHeight                  
        />
    );
};

export default ReportsDataGridDataGridPanel;
